"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpandRecord = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const use_meta_1 = require("./use_meta");
/**
 * you can use this methods to initialize, and get a more focused editing experience by executing the function
 * to expand a record modal.
 *
 * @returns A function that expands the modal for a record with the specified parameters.
 *
 * ### Example
 * ```js
 * import { useExpandRecord, useRecords } from '@apitable/widget-sdk';
 *
 * // expand first record
 * function ExpandFirstRecord() {
 *   const firstRecord = useRecords(view.id)[0];
 *   const expandRecord = useExpandRecord();
 *   return <button onClick={() => expandRecord({recordIds: [firstRecord?.id]})}>Expand first record</button>;
 * }
 * ```
 *
 */
function useExpandRecord() {
    const { expandRecord } = (0, react_1.useContext)(context_1.WidgetConfigContext);
    const metaDatasheetId = (0, use_meta_1.useMeta)().datasheetId;
    return (0, react_1.useCallback)(({ recordIds, viewId, datasheetId }) => {
        expandRecord({
            viewId,
            recordIds,
            activeRecordId: recordIds[0],
            datasheetId: datasheetId !== null && datasheetId !== void 0 ? datasheetId : metaDatasheetId,
        });
    }, [metaDatasheetId, expandRecord]);
}
exports.useExpandRecord = useExpandRecord;
